import {block} from '../utils/cn';

export const cnDropdownMenu = block('dropdown-menu');
